import { LoginRequest } from '../model/authModel';
import { apiCall } from './sharedAsync';
import { IUser } from '../reducers/authSlice';

export const apiLogin = async (payload: LoginRequest, rejectWithValue: (value: string)=>void) => {
    return apiCall<IUser, LoginRequest>("", "/user/login", "POST", rejectWithValue, "Login failed.", payload);    
}